import React from "react";
import { motion } from "framer-motion";

interface CollapseIconProps {
  isCollapsed: boolean;
  isHovered: boolean;
  className?: string;
}

export const CollapseIcon: React.FC<CollapseIconProps> = ({
  isCollapsed,
  isHovered,
  className = "w-5 h-5",
}) => {
  // Define paths for a doubled height
  const newHeight = 36; // Max Y for paths within a 40 unit viewBox
  const startY = 4; // Min Y for paths
  const midY = (startY + newHeight) / 2; // = 20

  const linePath = `M 10 ${startY} L 10 ${midY} L 10 ${newHeight}`; // Taller vertical line
  const chevronPathCollapsed = `M 9 ${startY} L 12 ${midY} L 9 ${newHeight}`; // Taller arrow >
  const chevronPathExpanded = `M 11 ${startY} L 8 ${midY} L 11 ${newHeight}`; // Taller arrow <

  const targetChevronPath = isCollapsed
    ? chevronPathCollapsed
    : chevronPathExpanded;

  // Define variants for the path morphing AND scaling
  const pathVariants = {
    initial: { d: linePath, scaleY: 1 }, // Line state is full height
    hovered: { d: targetChevronPath, scaleY: 0.8 }, // Chevron state is shorter
  };

  return (
    <svg
      viewBox="0 0 20 40"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <motion.path
        style={{ transformOrigin: "center center" }}
        variants={pathVariants}
        initial="initial"
        animate={isHovered ? "hovered" : "initial"}
        transition={{ duration: 0.2, ease: "easeInOut" }}
      />
    </svg>
  );
};
